module.exports = __webpack_public_path__ + "images/feature/file-dir-1-04a789d1373fd85579a0e097554984e7.png";